<div class="flex flex-col flex-auto w-full p-4 xs:p-2">
  <div class="flex flex-wrap w-full">
    <div class="flex items-center justify-between w-full mb-4 px-4 xs:pr-0">
      <div class="mr-6">
        <h2 class="m-0">Analytics</h2>
        <div class="text-secondary tracking-tight">Explore underwriting and analytics from your data.</div>
      </div>
      <div class="main-actions">
        <!-- Add contact button -->
        <button
          class="add-contact"
          mat-flat-button
          [color]="'primary'"
          (click)="addTimeSeriesChart()"
          [appAuthorize]="NewPermission.DEALS_EDIT"
          denyAction="disable"
        >
          <mat-icon [svgIcon]="'add'"></mat-icon>
          New Chart
        </button>
      </div>
    </div>
    <div class="w-full lt-xl:w-full">
      <ng-container *ngIf="timeSeriesFields$ | async as timeSeriesFields">
        <div
          class="flex flex-col flex-auto bg-card shadow-md rounded overflow-hidden mt-4"
          *ngFor="let chart of timeSeriesCharts"
        >
          <time-series-chart
            [editPermission]="NewPermission.DEALS_EDIT"
            [chart]="chart"
            [timeSeriesFields]="timeSeriesFields"
          ></time-series-chart></div
      ></ng-container>
    </div>
  </div>
</div>
